import type { ComponentProps } from 'react';
import { Splitter } from '@terra/ui-design-system';

type BorderedSplitterResizeTriggerProps = Pick<
  ComponentProps<typeof Splitter.ResizeTrigger>,
  'id'
> & {
  orientation: 'horizontal' | 'vertical';
};

const sharedProps = {
  flexShrink: 0,
  p: 0,
  m: 0,
  bg: 'border.subtle',
  position: 'relative' as const,
  zIndex: 10,
  _hover: {
    bg: 'border.default',
  },
};

const horizontalProps = {
  ...sharedProps,
  width: '1px',
  minWidth: '1px',
  cursor: 'col-resize',
  _before: {
    content: '""',
    position: 'absolute',
    inset: '0 -6px 0 -6px',
    cursor: 'col-resize',
    zIndex: 10,
  },
};

const verticalProps = {
  ...sharedProps,
  height: '1px',
  minHeight: '1px',
  cursor: 'row-resize',
  _before: {
    content: '""',
    position: 'absolute',
    inset: '-6px 0 -6px 0',
    cursor: 'row-resize',
    zIndex: 10,
  },
};

export function BorderedSplitterResizeTrigger({
  id,
  orientation,
}: BorderedSplitterResizeTriggerProps) {
  const props = orientation === 'horizontal' ? horizontalProps : verticalProps;

  return <Splitter.ResizeTrigger id={id} {...props} />;
}
